module.exports = __webpack_public_path__ + "static/media/mountain.5c6340a5.svg";